module.exports = __webpack_public_path__ + "static/img/jc2.f9e3ef2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/front/jc2.png
// module id = t9xk
// module chunks = 1